<div
  id="account-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_265px)]"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions">
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="created.emit()"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>
      <button
        mat-raised-button
        id="delete-all-btn"
        color="warn"
        class="tw-mr-2"
        (click)="deleteAll()"
        [disabled]="!selection.hasValue()"
      >
        <mat-icon>delete</mat-icon>
        <span>一括削除</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="tag-table"
      class="matp-table"
      mat-table
      matSort
      matSortActive="tagName"
      matSortDirection="asc"
      [dataSource]="dataSource"
    >
      <!-- チェックボックス -->
      <ng-container matColumnDef="checkbox">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="matp-table-header-middle !tw-min-w-min"
        >
          <mat-checkbox
            name="selectAll"
            color="primary"
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            name="select"
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null"
            [checked]="selection.isSelected(element)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- タグ名 -->
      <ng-container matColumnDef="tagName">
        <th mat-header-cell *matHeaderCellDef class="tw-w-full">
          <div class="matp-table-header-title">
            <span mat-sort-header>タグ名</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              name="tagName"
              type="text"
              [(ngModel)]="tagNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="tagname-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTagNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td
          mat-cell
          name="tagName"
          *matCellDef="let element"
          class="tw-truncate tw-max-w-20"
          app-tenant-setting-tag
        >
          <span class="tw-inline-block tw-rounded tw-p-1" [ngStyle]="tagStyle(element.color)">{{ element.tagName }}</span>
        </td>
      </ng-container>

      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-32 tw-max-w-32">
          <div class="matp-table-header-title">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-w-32">
          <button
            mat-stroked-button
            id="edit-btn"
            color="primary"
            (click)="updated.emit(element)"
          >
            <mat-icon>edit</mat-icon>
            <span>編集</span>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="account-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
